import {setSelectedCycle} from "../../handler/ParentDataHandler";
import {fetchCPTList} from "../network/ReceiveNetworkAPI";

export const ReceiverFilterReducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_CPT_LIST':
            fetchCPTList(action.data.dispatcher);
            return state;
        case 'INITIALIZE_CYCLES':
            let allCycles = JSON.parse(action.cycleData.cycleList).filter(cycle => cycle.cycleId !== "AllCycles").map(cycle => {
                return {
                    ...cycle, displayableName : cycle.cycleId
                }
            }).sort((cycle1, cycle2) => (cycle1.cycleName > cycle2.cycleName) ? 1 : ((cycle2.cycleName > cycle1.cycleName) ? -1 : 0));
            let selectedCycles = JSON.parse(action.cycleData.selectedCycles).filter(cycle => cycle !== "AllCycles");
            return {
                ...state,
                selectedCycles: selectedCycles.length ? selectedCycles : [allCycles[0].cycleId],
                allCycles: allCycles
            };
        case 'SELECT_CYCLE':
            setSelectedCycle([action.cycle]);
            return {
                ...state, selectedCycles: [action.cycle]
            };
        case 'SELECT_CPT':
            return {
                ...state,
                selectedCPT: [action.CPT]
            };
        case "RECEIVE_CPT":
            return {...state,
                allCPT: action.data.CPT,
                selectedCPT: action.data.CPT.filter(CPT => CPT.label === "ALL").map(CPT => CPT.id)
            };
        case "ASSIGN_LABEL":
            return {...state,
                CPTLabel: action.data.CPTLabel
            };
        case 'ASSIGN_FILTER_IDENTIFIER':
            return {...state,
                filterIdentifier: action.data.filterIdentifier
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/receive/reducers/ReceiveFilterReducer.js